<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <span v-on="on" class="from-now">{{string}}</span>
    </template>
    <span>{{dateString}}</span>
  </v-tooltip>
</template>
<script>
export default {
  data () {
    return {
      string: ''
    }
  },
  mounted () {
    this.setString()
    setInterval(() => { this.setString() }, 30000)
  },
  methods: {
    setString () {
      this.string = this._date ? this.$tkDate(this._date).fromNow() : ''
    }
  },
  watch: {
    date () {
      this.setString()
    }
  },
  computed: {
    _date () {
      return this.date || this.$slots.default[0].text
    },
    dateString () {
      return this._date ? this.$tkDate(this._date).format() : ''
    }
  },
  props: {
    date: String
  }
}
</script>
<style scoped lang="scss">
  .from-now {
    cursor: pointer;
  }
</style>
